export default { sha: '5e42d8d949514bc66ffafb8f68db50885bfbad72', buildNumber: 'undefined' }
